import * as actionTypes from "./navBarActionTypes";

const setOnTopAction = (onTop: boolean) => (dispatch: any) =>
    dispatch({ type: actionTypes.SET_ON_TOP, onTop });

const updateOnTopAction = (onTop: boolean) => (dispatch: any) =>
    dispatch({ type: actionTypes.UPDATE_ON_TOP, onTop });

export { setOnTopAction, updateOnTopAction };